import { render, staticRenderFns } from "./QuotaList.vue?vue&type=template&id=57c0cf15&scoped=true"
import script from "./QuotaList.vue?vue&type=script&lang=js"
export * from "./QuotaList.vue?vue&type=script&lang=js"
import style0 from "./QuotaList.vue?vue&type=style&index=0&id=57c0cf15&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0cf15",
  null
  
)

export default component.exports